import { useCallback, useSyncExternalStore } from 'react'

const supported = () => typeof matchMedia === 'function'

/** Whether the CSS media `query` matches now; false where `matchMedia` is missing (jsdom). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (!supported()) return () => {}
      const list = matchMedia(query)
      list.addEventListener('change', notify)
      return () => list.removeEventListener('change', notify)
    },
    [query],
  )
  return useSyncExternalStore(subscribe, () => supported() && matchMedia(query).matches)
}
